<!--
 * @Author: zxf
 * @Date: 2022-08-07 21:25:29
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:46:50
 * @Description: 维保报告数据推送
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        {{ dlTypeStr }}
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="请输入项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>

            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="计划名称"
                prop="project"
              >
                <el-input
                  v-model.trim="filterParams.project"
                  class="c-form__input"
                  placeholder="请输入计划名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="报告编号"
                prop="bgbh"
              >
                <el-input
                  v-model.trim="filterParams.bgbh"
                  class="c-form__input"
                  placeholder="请输入报告编号"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #bgbh="scope"
            >
              <el-link
                type="primary"
                :disabled="scope.row.previewPdf"
                @click="(e)=>$utils.previewPdf(e,scope.row.bgUrl, scope.row)"
              >
                <i
                  v-show="scope.row.previewPdf"
                  class="el-icon-loading"
                />
                {{ scope.row.bgbh }}
              </el-link>
            </template>
            <!-- <template
              #gzztMc="scope"
            >
              <span
                :class="{
                  'u-text-success' : scope.row.gzztDm==='1',
                  'u-text-danger' : scope.row.gzztDm==='0'
                }"
              >
                {{ scope.row.gzztMc }}
              </span>
            </template>
            <template
              #qgxtTsztMc="scope"
            >
              <span
                v-if="scope.row.qgxtTsztDm==='1'"
                class="u-text-success"
              >
                {{ scope.row.qgxtTsztMc }}
              </span>
              <el-link
                v-else
                :type="scope.row.qgxtTsztDm==='0' ? 'primary' : 'danger'"
                :underline="false"
                @click="handleQgxtSjts(scope.row.id)"
              >
                {{ scope.row.qgxtTsztMc }}
              </el-link>
            </template>
            <template
              #gdshptTsztMc="scope"
            >
              <span
                v-if="scope.row.gdshptTsztDm==='1'"
                class="u-text-success"
              >
                {{ scope.row.gdshptTsztMc }}
              </span>
              <el-link
                v-else
                :type="scope.row.gdshptTsztDm==='0'?'primary':'danger'"
                :underline="false"
                @click="handleGdshptSjts(scope.row.id)"
              >
                {{ scope.row.gdshptTsztMc }}
              </el-link>
            </template>
            <template
              #lwdwptTsztMc="scope"
            >
              <span
                v-if="scope.row.lwdwptTsztDm==='1'"
                class="u-text-success"
              >
                {{ scope.row.lwdwptTsztMc }}
              </span>
              <el-link
                v-else
                :type="scope.row.lwdwptTsztDm==='0' ? 'primary' : 'danger'"
                :underline="false"
                @click="handleLwdwptSjts(scope.row.id)"
              >
                {{ scope.row.lwdwptTsztMc }}
              </el-link>
            </template> -->
            <!-- <el-table-column
              prop="enabled"
              label="报告扫描件"
              width="140"
              align="center"
              fixed="right"
            > -->
            <template #otherFileId="scope">
              <span
                v-if="scope.row.gdshTsbz === 'Y'"
                class="u-text-success"
              >
                已上传
              </span>
              <k-button
                v-else-if="scope.row.otherFileId === 'Y'"
                btn-text="继续上传"
                :auth-type="true"
                show-text="无"
                type="success"
                :disabled="scope.row.gdshTsbz === 'Y'"
                plain
                @click="handleDialog('add', scope.row)"
              />
              <k-button
                v-else
                btn-text="上传"
                :auth-type="true"
                show-text="无"
                type="success"
                :disabled="scope.row.gdshTsbz === 'Y'"
                @click="handleDialog('add', scope.row)"
              />
            </template>
            <template
              #gdshTsbz="scope"
            >
              <span
                v-if="scope.row.gdshTsbz === 'Y'"
                class="u-text-success"
                style="cursor: pointer;"
                @click="handleDialog('wbbgResult', { bgId: scope.row.bgId, fd: scope.row});"
              >
                已推送
              </span>
              <span
                v-else-if="scope.row.gdshTsbz === 'U'"
                class="u-text-warning"
              >
                {{ scope.row.bglx === 'ZS' ? '待签章' : (scope.row.bglx === 'YQZ' ? '待盖章' : '-' ) }}
              </span>
              <k-button
                v-else
                btn-text="推送"
                :auth-type="true"
                type="primary"
                @click="handleGdshptSjts(scope.row)"
              />
              <!-- <k-button
          btn-text="导出"
:auth-type="false"
                v-else
                type="primary"
                @click="handleDialog('wbbgResult', { bgId: scope.row.bgId, fd: scope.row});"
              >
                推送
              </k-button> -->
            </template>
            <template
              #gdshTsbz="scope"
            >
              <span
                v-if="scope.row.gdshTsbz === 'Y'"
                class="u-text-success"
                style="cursor: pointer;"
                @click="handleDialog('wbbgResult', { bgId: scope.row.bgId, fd: scope.row});"
              >
                已推送
              </span>
              <span
                v-else-if="scope.row.gdshTsbz === 'U'"
                class="u-text-warning"
              >
                {{ scope.row.bglx === 'ZS' ? '待签章' : (scope.row.bglx === 'YQZ' ? '待盖章' : '-' ) }}
              </span>
              <k-button
                v-else
                btn-text="推送"
                :auth-type="true"
                type="primary"
                @click="handleGdshptSjts(scope.row)"
              />
              <!-- <k-button
          btn-text="导出"
:auth-type="false"
                v-else
                type="primary"
                @click="handleDialog('wbbgResult', { bgId: scope.row.bgId, fd: scope.row});"
              >
                推送
              </k-button> -->
            </template>
            <template
              #szptTsbz="scope"
            >
              <span
                v-if="scope.row.szptTsbz === 'Y'"
                class="u-text-success"
                style="cursor: pointer;"
                disabled
              >
                已推送
              </span>
              <span
                v-else-if="scope.row.gdshTsbz === 'U'"
                class="u-text-warning"
              >
                {{ scope.row.bglx === 'ZS' ? '待签章' : (scope.row.bglx === 'YQZ' ? '待盖章' : '-' ) }}
              </span>
              <k-button
                v-else
                btn-text="推送"
                :auth-type="true"
                type="primary"
                @click="handleDialog('szpt', { bgId: scope.row.bgId, fd: scope.row});"
              />
              <!-- <k-button
          btn-text="导出"
:auth-type="false"
                v-else
                type="primary"
                @click="handleDialog('wbbgResult', { bgId: scope.row.bgId, fd: scope.row});"
              >
                推送
              </k-button> -->
            </template>
            <el-table-column
              prop="enabled"
              label="全国系统"
              width="120"
              align="center"
              fixed="right"
            >
              <template>
                <k-button
                  btn-text="推送"
                  :auth-type="true"
                  type="primary"
                  plain
                  disabled
                  @click="handleAdd()"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>

      <div class="o-tips">
        报告推送成功后不能修改报告信息
      </div>
    </div>
    <!-- 页面主内容：查询列表 End -->
    <wbjh-update-dialog
      v-if="showDialogName==='add'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <!-- 页面主内容：查询列表 End -->
    <wbbg-result-dialog
      v-if="showDialogName==='wbbgResult'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
    <SzptDialog
      v-if="showDialogName==='szpt'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>

<script>
import { bgglService } from './bggl.service';
import WbjhUpdateDialog from './wjscDialog.vue';
import WbbgResultDialog from './wbbgtsResult.vue';
import SzptDialog from '@/features/xfwbgl/bggl/szptDialog.vue';

export default {
  name: 'JcsjtsIndex',
  components: {
    WbjhUpdateDialog,
    WbbgResultDialog,
    SzptDialog
  },

  data () {
    return {
      loading: false, // 页面是否loading状态
      lwdws: [], // 联网单位
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        bgbh: null, // 报告编号
        jhmc: null, // 计划名称
        xmmc: null, // 项目名称
        bgType: 'XFWBSYBG',
        bglx: ['DGZ', 'DQZ', 'YQZ', 'YGZ', 'YFB'] // 计划状态代码
        /* xmmc: null, // 项目名称
        bgbh: null, // 报告编号
        bgType: 'XFWBBGTS' // 推送类型，维保：WB */
      },
      /* 查询条件 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'bgbh', slotName: 'bgbh', label: '报告编号', align: 'left', minWidth: '120', type: 'text' },
        { key: 'xmmc', label: '项目名称', align: 'left', minWidth: '140', type: 'text' },
        { key: 'jhmc', label: '计划名称', align: 'left', minWidth: '100', type: 'text' },
        { key: 'xmfzrMc', label: '项目负责人', align: 'left', width: '100', type: 'text' },
        { key: 'lrdw', label: '所属账号', align: 'left', minWidth: '120', type: 'text' },
        { key: 'otherFileId', slotName: 'otherFileId', label: '报告上传', align: 'center', width: '120', type: 'text' },
        { key: 'gdshTsbz', slotName: 'gdshTsbz', label: '广东社会平台', align: 'center', width: '120', type: 'text' },
        { key: 'szptTsbz', slotName: 'szptTsbz', label: '消防数字平台', align: 'center', width: '170', type: 'text' }
      ],
      /* 表格列配置End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */

    };
  },
  computed: {
    /** 动态获取路由名称 */
    dlType () {
      return this.$route.name;
    },
    dlTypeStr () {
      return this.$route.meta.navtabTitle;
    }
  },
  methods: {
    /**
     * @description: 全国系统数据推送
     * @return {*}
     * @param {*} _id
     */
    handleQgxtSjts (_id) {
      const _this = this;
      _this.$confirm('是否确认将数据推送全国系统？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        bgglService.qgxtSjts(_id)
          .then(rsp => {
            _this.$alert('推送数据到全国系统成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
                this.refreshSearch();
              }
            });
          })
          .catch(err => {
            console.error('推送错误！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      });
    },
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },
    /**
     * @description: 广东社会平台数据推送
     * @return {*}
     * @param {*} _id
     */
    handleGdshptSjts (_data) {
      const _xmId = _data.xmId;
      const _bgId = _data.bgId;
      const _this = this;
      const confirmText = [
        '是否确认将数据推送广东社会平台？',
        '注意：',
        '   1、已推送成功的报告不能重复上传报告；',
        '   2、推送的报告以最新上传的报告为准；',
        '   3、上传报告必须是电子报告（电子公章）或原件扫描件（公司印章及签名）；',
        '   4、报告推送成功后不能修改报告信息。'
      ];
      const newCText = [];
      const h = this.$createElement;
      for (const i in confirmText) {
        newCText.push(h('p', null, confirmText[i]));
      }

      _this.$confirm('确认', {
        title: '确认',
        message: h('div', null, newCText),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        bgglService.gdshptSjts(_xmId, _bgId)
          .then(rsp => {
            this.handleDialog('wbbgResult', { bgId: _bgId, fd: _data, flag: rsp.data.data });
            this.refreshSearch();
            // _this.$alert('推送数据成功！', '提示', {
            //   confirmButtonText: '确定',
            //   type: 'success',
            //   callback: action => {
            //     this.refreshSearch();
            //   }
            // });
          })
          .catch(err => {
            console.error('推送错误！', err);
            this.handleDialog('wbbgResult', { bgId: _bgId });
          })
          .finally(() => {
            _this.loading = false;
          });
      });
    },
    /**
     * @description: 联网单位平台数据推送
     * @return {*}
     * @param {*} _id
     */
    handleLwdwptSjts (_id) {
      const _this = this;
      _this.$confirm('是否确认将数据推送联网单位平台？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        bgglService.lwdwptSjts(_id)
          .then(rsp => {
            _this.$alert('推送数据成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
                this.refreshSearch();
              }
            });
          })
          .catch(err => {
            console.error('查询错误！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      });
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      bgglService.getWbbgSjts(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>

<style scoped lang="scss">
.o-tips {
  position: absolute;
  top: 4px;
  right: 12px;
  z-index: 9;
  padding-left: 8px;
  border-left: 0;
  color: #f56c6c;
  background-color: #fef0f0;
}
</style>
